/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import {useDispatch} from 'react-redux'
import * as Yup from 'yup'
import clsx from 'clsx'
import {useFormik} from 'formik'
import * as auth from '../redux/AuthRedux'
import {login} from '../redux/AuthCRUD'
import {useIntl} from "react-intl";
import NormalCustomCheckbox from '../../../components/Control/NormalCustomCheckbox'
import { Link } from 'react-router-dom'

const initialValues = {
  user_name: '',
  password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const [showPassword, setShowPassword] = useState(false)
  const intl = useIntl()


  const loginSchema = Yup.object().shape({
    user_name: Yup.string()
      .max(50, intl.formatMessage({id: 'COMMON.MAX_SYMBOLS'}, {max: 50}))
      .required(intl.formatMessage({id: 'COMMON.REQUIRED'}, {name: 'tên người dùng'})),
    password: Yup.string()
      .min(3, intl.formatMessage({id: 'COMMON.MIN_SYMBOLS'}, {min: 3}))
      .max(50, intl.formatMessage({id: 'COMMON.MAX_SYMBOLS'}, {max: 50}))
      .required(intl.formatMessage({id: 'COMMON.REQUIRED'}, {name: 'mật khẩu'})),
  })


  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setTimeout(() => {
        login(values.user_name, values.password)
          .then(({data: {access_token}}) => {
            setLoading(false)
            dispatch(auth.actions.login(access_token))
          })
          .catch((err: any) => {
            let errMesssage = err?.message ? err.message + `(${process.env.REACT_APP_API_URL})` : 'Đã xay ra lỗi trong quá trình đăng nhập!';
            if (err?.response?.data?.message) {
              errMesssage = err.response.data.message
            } else if (err?.response?.data?.error) {
              errMesssage = err.response.data.error
            }
            setLoading(false)
            setSubmitting(false)
            setStatus(errMesssage)
          })
      }, 1000)
    },
  })

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {/* begin::Heading */}
      <div className='text-center mb-10'>
        <h1 className='text-dark mb-3'>Sento - Nhà cung cấp</h1>
      </div>
      {/* begin::Heading */}

      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )
      }

      <div className='fv-row mb-10'>
        <label className='form-label fs-6 fw-bolder text-dark'>Email</label>
        <input
          placeholder=''
          {...formik.getFieldProps('user_name')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {'is-invalid': formik.touched.user_name && formik.errors.user_name},
            {
              'is-valid': formik.touched.user_name && !formik.errors.user_name,
            }
          )}
          type='user_name'
          name='user_name'
          autoComplete='off'
        />
        {formik.touched.user_name && formik.errors.user_name && (
          <div className='fv-plugins-message-container text-danger'>
            <span role='alert'>{formik.errors.user_name}</span>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <div className='d-flex justify-content-between mt-n5'>
          <div className='d-flex flex-stack mb-2'>
            {/* begin::Label */}
            <label className='form-label fw-bolder text-dark fs-6 mb-0'>Mật khẩu</label>
            {/* end::Label */}
          </div>
        </div>
        <input
          type={showPassword ? 'text' : 'password'}
          autoComplete='off'
          {...formik.getFieldProps('password')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {
              'is-invalid': formik.touched.password && formik.errors.password,
            },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
        />
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block text-danger'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}
      <div className='fv-row mb-2 justify-content-between d-flex'>
        <NormalCustomCheckbox 
            name={'showPassword'} 
            label={'Hiển thi thị mật khẩu'}
            checked={showPassword}
            handleChange={() => setShowPassword(!showPassword)}
        />
        <Link to='/auth/reset-password'>
            Quên mật khẩu?
        </Link>
      </div>
      {/* begin::Action */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>Đăng nhập</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
             {intl.formatMessage({id: 'COMMON.PLEASE_WAIT'})}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Action */}
    </form>
  )
}
